
		<info-modal [title]="title" (onOk)="ok()">
			<select [(ngModel)]="flag" [ngModelOptions]="{standalone: true}" class="form-control">
				<option *ngFor="let opt of cacheTaskList"
						value="{{ opt }}" [selected]="opt == flag">
					{{ opt }}
				</option>
			</select>
		</info-modal>
	